/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Box,
  Flex,
  Link,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@tonic-one/react';
import isEqual from 'lodash/isEqual';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ButtonTab from 'src/components/Common/ButtonTab';
import { TitleLabel } from 'src/components/Common/FormComponent';
import NotifyAdmin from 'src/components/FilterNotification/NotifyAdmin';
import NotifyUser from 'src/components/FilterNotification/NotifyUser';
import {
  DlpPolicyItem,
  EnableDisableStatus,
} from 'src/pages/Policy/utils/types';
import { useWhyDidYouUpdate } from 'src/utils/hooks';

import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import { PolicyTypeEnum } from '@Policy/utils/constants';
import DlpAdvancedOptionModal from '@Policy/DataLossPrevention/Components/AdvanceOption/DlpAdvancedOptionModal';
import { dlpAdvancedOptionConfigSelector } from '@Policy/store/filters/dlp';

export const DlpFileAdvancedOption = ({
  replaceFileNameShow,
  availableTokenShow,
  mipFeatureShow,
  syncLabels,
}: {
  availableTokenShow: boolean;
  replaceFileNameShow: boolean;
  mipFeatureShow: boolean;
  syncLabels?: () => void;
}) => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const advancedOptionConfig = contextSelector(
    dlpAdvancedOptionConfigSelector,
    isEqual
  );
  // get action from store
  const setDpState = contextSelector((s) => s.setDpState);
  // advanced option
  const [isVisible, setIsVisible] = React.useState(false);
  const handleAdvancedOptionClose = React.useCallback(() => {
    setIsVisible(false);
  }, []);
  const handleAdvancedOptionSave = React.useCallback(
    ({ replaceText }: { replaceText: string }) => {
      setDpState({
        dpReplacementText: replaceText,
      });
    },
    []
  );
  const policyType = policySelector((s) => s.policyType);
  useWhyDidYouUpdate('Data Loss prevention ,dlp AdvancedOption', {
    advancedOptionConfig,
    isVisible,
  });
  return (
    <Box mt={16}>
      <Link mr="24px" onClick={() => setIsVisible(!isVisible)}>
        {t('policy.action.advanced.title')}
      </Link>
      <DlpAdvancedOptionModal
        replacementTextDesc={
          [
            PolicyTypeEnum.SharePoint,
            PolicyTypeEnum.OneDrive,
            PolicyTypeEnum.Box,
            PolicyTypeEnum.Dropbox,
            PolicyTypeEnum.GoogleDrive,
            PolicyTypeEnum.Teams,
          ].includes(policyType)
            ? t('policy.action.replaceAction.quarantineOrDelete.desc')
            : t('policy.action.replaceAction.desc')
        }
        availableTokenShow={availableTokenShow}
        replaceFileNameShow={replaceFileNameShow}
        mipFeatureShow={mipFeatureShow}
        isVisible={isVisible}
        syncLabels={syncLabels}
        onClose={handleAdvancedOptionClose}
        config={advancedOptionConfig}
        saveConfig={handleAdvancedOptionSave}
      />
    </Box>
  );
};

function ActionNotification() {
  const { t } = useTranslation();

  // get store from context
  const contextStore = usePolicyContext();
  const policySelector = templateSelector(contextStore)<DlpPolicyItem>;
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state and action from store
  const ntfAdminIntervalNum = policySelector(
    (s) => s.tmDpfilters.notification.ntfAdminIntervalNum
  );
  const ntfAdminIntervalType = policySelector(
    (s) => s.tmDpfilters.notification.ntfAdminIntervalType
  );
  const ntfAdminMessage = policySelector(
    (s) => s.tmDpfilters.notification.ntfAdminMessage
  );
  const ntfAdminNotifySettingType = policySelector(
    (s) => s.tmDpfilters.notification.ntfAdminNotifySettingType
  );
  const ntfAdminSubject = policySelector(
    (s) => s.tmDpfilters.notification.ntfAdminSubject
  );
  const ntfEnableNotifyAdmin = policySelector(
    (s) => s.tmDpfilters.notification.ntfEnableNotifyAdmin
  );
  const ntfEnableNotifyRecipient = policySelector(
    (s) => s.tmDpfilters.notification.ntfEnableNotifyRecipient
  );
  const ntfInternalRecipientMessage = policySelector(
    (s) => s.tmDpfilters.notification.ntfInternalRecipientMessage
  );
  const ntfInternalRecipientSubject = policySelector(
    (s) => s.tmDpfilters.notification.ntfInternalRecipientSubject
  );
  const ntfToAccount = policySelector(
    (s) => s.tmDpfilters.notification.ntfToAccount
  );
  const ntfAdminOccurenceNum = policySelector(
    (s) => s.tmDpfilters.notification.ntfAdminOccurenceNum
  );
  const ntfRecipientGroupId = policySelector(
    (s) => s.tmDpfilters.notification.ntfRecipientGroupId
  );
  const ntfRecipientGroupEnabled = policySelector(
    (s) => s.tmDpfilters.notification.ntfRecipientGroupEnabled
  );
  const recipientGroups = contextSelector((s) => s.recipientGroups);
  const setDpNtfState = contextSelector((s) => s.setDpNtfState);

  // local state
  const handleNtfEnableAdminChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setDpNtfState({
        ntfEnableNotifyAdmin: e.target.checked ? 1 : 0,
      });
    },
    []
  );
  const handleNtfAdminToAccountChange = useCallback((toAccount: string) => {
    setDpNtfState({ ntfToAccount: toAccount });
  }, []);
  const handleNtfAdminNotifySettingTypeChange = useCallback(
    (notifySettingType: number) => {
      setDpNtfState({
        ntfAdminNotifySettingType: notifySettingType,
      });
    },
    []
  );
  const handleNtfAdminSubjectChange = useCallback((subject: string) => {
    setDpNtfState({ ntfAdminSubject: subject });
  }, []);
  const handleNtfAdminMessageChange = useCallback((message: string) => {
    setDpNtfState({ ntfAdminMessage: message });
  }, []);
  const handleNtfAdminIntervalNumChange = useCallback((intervalNum: number) => {
    setDpNtfState({ ntfAdminIntervalNum: intervalNum });
  }, []);
  const handleNtfAdminIntervalTypeChange = useCallback(
    (intervalType: number) => {
      setDpNtfState({ ntfAdminIntervalType: intervalType });
    },
    []
  );
  const handleNtfAdminOccurenceNumChange = useCallback(
    (occurenceNum: number) => {
      setDpNtfState({ ntfAdminOccurenceNum: occurenceNum });
    },
    []
  );
  const handleNtfRecipientGroupIdChange = useCallback(
    (recipientGroupId: number) => {
      setDpNtfState({ ntfRecipientGroupId: recipientGroupId });
    },
    []
  );
  const handleNtfRecipientGroupEnabledChange = useCallback(
    (enabled: EnableDisableStatus) => {
      setDpNtfState({ ntfRecipientGroupEnabled: enabled });
    },
    []
  );
  const handleNtfEnableRecipientChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setDpNtfState({
        ntfEnableNotifyRecipient: e.target.checked ? 1 : 0,
      });
    },
    []
  );
  const handleNtfInternalRecipientSubjectChange = useCallback(
    (subject: string) => {
      setDpNtfState({ ntfInternalRecipientSubject: subject });
    },
    []
  );
  const handleNtfInternalRecipientMessageChange = useCallback(
    (message: string) => {
      setDpNtfState({ ntfInternalRecipientMessage: message });
    },
    []
  );
  useWhyDidYouUpdate('Antispam ActionNotification', {
    ntfAdminIntervalNum,
    ntfAdminIntervalType,
    ntfAdminMessage,
    ntfAdminNotifySettingType,
    ntfAdminSubject,
    ntfEnableNotifyAdmin,
    ntfEnableNotifyRecipient,
    ntfInternalRecipientMessage,
    ntfInternalRecipientSubject,
    ntfToAccount,
    ntfAdminOccurenceNum,
    ntfRecipientGroupId,
    recipientGroups,
  });
  return (
    <div>
      <Box ml="1px" mt="16px" width="100%">
        <Flex direction="column">
          <TitleLabel title={t('policy.notification')} />
          <Tabs mt="24px">
            <TabList>
              <ButtonTab>{t('policy.notification.admin')}</ButtonTab>
              <ButtonTab>{t('policy.notification.user')}</ButtonTab>
            </TabList>
            <TabPanels py="24px">
              <TabPanel>
                <NotifyAdmin
                  status={ntfEnableNotifyAdmin}
                  toAccount={ntfToAccount}
                  notifySettingType={ntfAdminNotifySettingType}
                  subject={ntfAdminSubject}
                  message={ntfAdminMessage}
                  intervalNum={ntfAdminIntervalNum}
                  intervalType={ntfAdminIntervalType}
                  occurenceNum={ntfAdminOccurenceNum}
                  recipientGroupId={ntfRecipientGroupId}
                  recipientGroups={recipientGroups}
                  recipientGroupEnabled={ntfRecipientGroupEnabled}
                  setStatus={handleNtfEnableAdminChange}
                  setToAccount={handleNtfAdminToAccountChange}
                  setNotifySettingType={handleNtfAdminNotifySettingTypeChange}
                  setSubject={handleNtfAdminSubjectChange}
                  setMessage={handleNtfAdminMessageChange}
                  setIntervalNum={handleNtfAdminIntervalNumChange}
                  setIntervalType={handleNtfAdminIntervalTypeChange}
                  setOccurenceNum={handleNtfAdminOccurenceNumChange}
                  setRecipientGroupId={handleNtfRecipientGroupIdChange}
                  setRecipientGroupEnabled={
                    handleNtfRecipientGroupEnabledChange
                  }
                />
              </TabPanel>
              <TabPanel>
                <NotifyUser
                  status={ntfEnableNotifyRecipient}
                  subject={ntfInternalRecipientSubject}
                  message={ntfInternalRecipientMessage}
                  setStatus={handleNtfEnableRecipientChange}
                  setSubject={handleNtfInternalRecipientSubjectChange}
                  setMessage={handleNtfInternalRecipientMessageChange}
                />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Flex>
      </Box>
    </div>
  );
}

export default React.memo(ActionNotification);
